<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <!-- <div class="message-box">
            <w-transition-fade>
                <w-alert
                    class="my0 text-light"
                    v-if="form.submitted"
                    success
                    no-border
                >
                    The form is valid, ready to send it!
                </w-alert>

                <w-alert
                    class="my0 text-light"
                    v-else-if="form.valid === false"
                    error
                    no-border
                >
                    Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
            </w-transition-fade>
        </div> -->
       <w-dialog
            v-model="modal.show"
            :fullscreen="modal.fullscreen"
            :width="dialog.width"
            :persistent="modal.persistent"
            :persistent-no-animation="modal.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Paparan Butiran Cukai </template>
                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Nama : 
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.nama}}</div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Pejabat Tanah :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.jabatan}} </div>
                    </div>
                </w-flex>

                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Alamat :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.alamat}}</div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Daerah :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form_cukai.daerah}} </div>
                    </div>
                </w-flex>
                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Mukim/Bandar/Pekan :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.mukim}} </div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Tarikh Daftar :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form_cukai.tarikh_daftar)}}</div>
                    </div>
                </w-flex>
                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                             Jenis Hakmilik :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form_cukai.hm_jenis}} </div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              No. Lot :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form_cukai.no_lot}} </div>
                    </div>
                </w-flex>
                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                             No. KP :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.no_kp}}</div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Keluasan :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form_cukai.keluasan}} {{form_cukai.unit_keterangan}} </div>
                    </div>
                </w-flex>
                <w-flex justify-left>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                             No. Hakmilik :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form_cukai.no_hm}}</div>
                    </div>
                    <div class="xs6">
                          <h5 class="fw-semibold m0">
                              Kegunaan :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{form_cukai.hm_kegunaan}} </div>
                    </div>
                </w-flex>

                <br><br>
            <table class="table-dashboard" width="100%">
                <thead>
                    <tr>
                        <!-- <th>Jabatan</th>
                        <th>Nama Profil</th> -->
                        <th rowspan="2">Kod Akaun</th>
                        <th colspan="6">amaun (RM)</th>
                    </tr>
                        <th>Cukai</th>
                        <th>Telah Bayar</th>
                        <th>Pelarasan</th>
                        <th>Ampun Hasil</th>
                        <th>Diskaun</th>
                        <th>Baki</th>
                    <tr>

                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(d, index) in cukai">
                       <!--  <td>{{ d.profil_nama }}</td>
                        <td>{{ d.no_hm }}</td> -->
                        <td>{{ d.akaun_keterangan }}</td>
                        <td align="right">
                            {{ $zutil.currency(d.rm_debit) }}
                        </td>
                        <td align="right">
                            {{ $zutil.currency(d.rm_resit) }}
                        </td>
                        <td align="right">
                            {{ $zutil.currency(d.rm_kredit) }}
                        </td>
                        <td align="right">
                            {{ $zutil.currency(d.rm_ampun_hasil) }}
                        </td>
                        <td align="right">
                            {{ $zutil.currency(d.rm_diskaun) }}
                        </td>
                        <td align="right">
                            {{ $zutil.currency(d.baki) }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <b>Jumlah</b>
                        </td>
                        <td align="right">
                            <b>{{ $zutil.currency(form.amaun) }}</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="modal.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

         <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Tambah Profil
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submitProfil" @success="success">
                        <template ></template><br>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat *" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                              <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                </template>
            </w-dialog>


            <w-card bg-color="" class="">
                <h3>Tambah Profil</h3>
                <br /><br />

                <w-flex class="mt3">
                    <z-input
                        label="Profil *"
                        v-model="form.profil_keterangan"
                        name="profil_id"
                        readonly
                        @click="profil"
                    />
                    <div class="xs1">
                        &nbsp;
                        <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                    </div>
                </w-flex>

                <br />
                <w-flex justify-center align-center v-if="form.profil_keterangan">
                    <div class="xs6">
                        <h5 class="fw-semibold m0">Profil :</h5>
                        <!-- {{form.no_id}}  {{form.nama}} -->
                        {{ form.profil_keterangan }}
                    </div>

                    <div class="xs6">
                        <h5 class="fw-semibold m0">Alamat :</h5>
                        {{ form.profil_alamat }} {{ form.poskod }}
                        {{ form.bandar }} {{ form.negeri }}
                    </div>
                </w-flex> 
            </w-card>

        
        <br>
        <w-card bg-color="" class="">
            <w-flex justify-space-between class="mb4">
                <!-- <div class="xs7"> -->
                <!-- <w-input v-model="form_cari.no_rujukan" name="no_rujukan" label="No Rujukan" /> -->

                <!--  <w-input
                    v-model="form_cari.no_rujukan"
                    name="no_rujukan"
                    label="No Rujukan"
                    @click="profilhm"
                /> -->
                <w-input
                    v-model="form_cari.no_rujukan"
                    name="no_rujukan"
                    label="No Rujukan"
                    @change="Detail()"
                />

                <!-- </div> -->

                <div class="xs1">
                    <!-- <w-icon @click="Detail()">fal fa-search</w-icon> -->
                    <w-icon>fal fa-search</w-icon>
                    &nbsp;
                    <w-icon @click="profilhm">fal fa-plus</w-icon>
                    <!-- &nbsp;
                    <w-icon v-on:keyup="Detail()">fal fa-qrcode</w-icon> -->

                    <!-- <w-button class="ml1" @click="profilhm">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button> -->
                    <!--  <w-button class="ml1 " @click="Detail()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button> -->
                </div>
            </w-flex>
            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <!-- <w-flex justify-space-between class="mb4">
                <w-input
                    v-model="form_carian.no_rujukan"
                    name="no_rujukan"
                    label="Barcode No Rujukan"
                    v-on:keyup="Detail()"
                />
                <div class="xs1"></div>
            </w-flex> -->
        </w-card>
        <w-alert bg-color="red" color="white"

            class="my0 mb2 text-light"
            v-if="halangan"
            transition="bounce"
            plain
            round
           
            >
            <w-flex class="wrapper">
                {{ halangan }}
                <div class="spacer"></div>
                <w-icon
                md
                color="red"
                bg-color="white"
                 @click="halangan = null" >
                 mdi mdi-close</w-icon>
            </w-flex>
        </w-alert>

       
       
         <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitTerimaanPukal" @success="onSuccess">
         <z-page title="Butiran Bayaran (Cukai)">
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Nama Pemilik</td>
                                <td>No. Hakmilik</td>
                                <!-- <td>Kod Akaun</td> -->
                                <!-- <td>Butiran</td> -->
                                <td>Amaun (RM)</td>
                                <td>Amaun Bayar (RM)</td>
                                <td>
                                    <!-- <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon> -->
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dat, index) in hm_cukai">
                                {{index+1}}
                                <td>
                                    {{ dat.nama }}
                                </td>
                                <td>
                                    {{ dat.no_rujukan }}
                                </td>

                                <td align="right">
                                    {{ $zutil.currency(dat.amaun_asal) }}
                                </td>
                                <td>
                                    <z-money
                                        v-model:originalValue="dat.amaun"
                                        required
                                        v-on:keyup="cekAmaunCukai(dat)"
                                    />
                                </td>
                                <td>
                                    <w-icon
                                        class="mr1"
                                        @click="removeCukai(index)"
                                        >fal fa-trash</w-icon
                                    >
                                    &nbsp;
                                    <w-icon
                                        tile
                                        @click="show(dat)"
                                        title="Papar"
                                        >fal fa-eye</w-icon
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" align="right">Jumlah (RM)</td>
                                <td align="right"><b>{{$zutil.currency(amaun_jumlah_cukai)}}</b></td>
                            </tr>
                            <tr>
                                <td colspan="4" align="right">
                                    Penggenapan (RM)
                                </td>
                                <td align="right"><b>0</b></td>
                            </tr>
                            <tr>
                                <td colspan="4" align="right">
                                    Jumlah Dibayar (RM)
                                </td>
                                <td align="right">
                                    <b>{{
                                        $zutil.currency(amaun_jumlah_cukai)
                                    }}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
             
            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="form.profil_keterangan">
                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                </w-button>
                </template>
            </w-flex>
        </z-page>

        </w-form>


      

        <w-dialog
            v-model="dialogProfil.show"
            :fullscreen="dialogProfil.fullscreen"
            :width="dialogProfil.width"
            :persistent="dialogProfil.persistent"
            :persistent-no-animation="dialogProfil.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No KP | Nama (Carian minimun 2 aksara)"
                            v-model="carian_profil.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" @click="cariProfil"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <div class="table-profil-scrol">
                    <table class="w-table">
                        <thead>
                            <tr>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    No KP | Nama
                                </th>
                                <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Pilih
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in profils">
                                <td class="w-table__cell text-left">
                                    {{ index + 1 }}
                                </td>
                                <td class="w-table__cell">
                                    {{ dt.label }}
                                </td>
                                <td class="w-table__cell text-right">
                                    <w-radio
                                        class="mr2"
                                        v-model="form.profil_id"
                                        :return-value="dt.value"
                                        @click="pilihProfil(dt)"
                                    ></w-radio>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfil.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

        <w-dialog
            v-model="dialogProfilhm.show"
            :fullscreen="dialogProfilhm.fullscreen"
            :width="dialogProfilhm.width"
            :persistent="dialogProfilhm.persistent"
            :persistent-no-animation="dialogProfilhm.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
            </template>
            <div class="page-wrapper-portal">
                <w-flex justify-center align-center>
                    <div class="xs8">
                        <w-input
                            label="No. KP | Nama | No. Hakmilik | No. Lot (Carian minimun 3 aksara)"
                            v-model="carian_profil_hm.q"
                        >
                        </w-input>
                    </div>
                    <div class="xs4">
                        <w-button class="ml1" 
                    :loading="dialog.loading" @click="cariProfilhm"
                            >Cari</w-button
                        >
                    </div>
                </w-flex>
                <br /><br />
                <div class="table-profil-scrol">
                    <z-page title="Butiran Bayaran (Cukai)">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. ID | Nama
                                    </th>
                                    <!-- <th
                                    class="w-table__header w-table__header--sortable text-left"
                                >
                                    Jabatan
                                </th> -->
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Rujukan
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No. Lot/ No. PT
                                    </th>

                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Amaun
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-center"
                                    >
                                        <w-checkbox
                                            v-model="pilih_akaun"
                                            @click="cekPilih"
                                        ></w-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in draf_akaun">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.profil_nama }}
                                    </td>
                                    <!-- <td class="w-table__cell">
                                    {{ dt.jabatan_keterangan }}
                                </td> -->
                                    <td class="w-table__cell">
                                        {{ dt.no_hm }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.no_lot }}
                                    </td>

                                    <td class="w-table__cell">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                    <td class="w-table__cell text-center">
                                        <!-- <w-radio class="mr2" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)"></w-radio> -->

                                        <!-- <w-icon class="mr1" v-model="form.no_rujukan" :return-value="dt.id" @click="pilihProfilhm(dt)">fal fa-plus</w-icon> -->

                                        <w-checkbox
                                            v-model="dt.pilih_akaun"
                                        ></w-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </z-page>
                    <br /><br />
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="hantarRujukan"
                    >Hantar</w-button
                >
                &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialogProfilhm.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            pilih_akaun: false,
            pilih_inbois: false,
            halangan : null,
            resourceurl: this.service_kutipan + "terimaan_pukal",
            reload: true,
            hm_cukai: [],
            butiran: [],
            error_termilan : null,
            // form_cari : [],

            form_cari: {},
            form_carian: {},
            amaun_bayaran: 0,
            amaun_butiran: 0,
            cukai: [],
            butir: [],
            draf_akaun: [],
            draf_inbois: [],
            amaun_jumlah_cukai: 0,
            form_profil: {},
            form_cari: {},
            carian_profil: { q: "" },
            kategori: [
                    {
                        value: 1,
                        label: "Individu",
                    },
                    {
                        value: 2,
                        label: "Syarikat",
                    },
                ],

            profils: [],
            loading : false,
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                form: { nama: "", email: "" },
            },

            dialogButiran: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                butir: [],
            },
            connection: null,
            form_profil_hm: {},
            carian_profil_hm: { q: "" },
            profils: [],
            dialogProfilhm: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                pilih_akaun: false,
                pilih_inbois: false,
                form: { nama: "", email: "" },
            },
            terimaan_pukal : {},
            terminal : {},
            cara_bayaran : [],
            bank : [],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Terimaan Pukal", route: "/kutipan/terimaan_pukal" },
            ],
        };
    },
    
    created: function() {
        
        

    },

    methods: {
       

        show(dat) {
            this.form_cukai = dat
            this.cukai = dat.hm_cukai;
            this.modal.show = true;
        },

        
        removeBayar(index) {
            this.form.cara_bayaran.splice(index, 1);
        },

        removeCukai(index) {
            this.hm_cukai.splice(index, 1);

            this.cekAmaunCukai();
        },

        cekAmaunBayar(d) {
            d.baki = d.amaun;

            this.cekAmaunTotalBayar();
        },


        cekAmaunTotalBayar() {
            this.amaun_bayaran = 0;
            for (var i in this.form.cara_bayaran) {
                this.amaun_bayaran =
                    this.amaun_bayaran +
                    parseFloat(this.form.cara_bayaran[i].amaun);
            }
            // this.cekJumlahBayar()
        },

       

        cekAmaunCukai() {
            this.amaun_jumlah_cukai = 0;
            for (var i in this.hm_cukai) {
                this.amaun_jumlah_cukai =
                    this.amaun_jumlah_cukai +
                    parseFloat(this.hm_cukai[i].amaun);
            }
            // this.totalKenaBayar()
        },

        
        cekKeluasan(dat) {
            form.keluasan = dat.amaun_debit - dat.amaun_diskaun;
            this.cekTotal();
            // for (var i in this.form.butiran) {
            // }
        },

        Detail() {
            this.halangan = null
            if(this.loading == false){
            this.loading = true
            this.$zcomm
                .get(
                    this.service_kutipan +
                        "terimaan" +
                        "?no_rujukan=" +
                        this.form_cari.no_rujukan+'&jenis='+2
                )
                .then((res) => {
                    console.log(res.data);
                    this.loading = false
                    this.form_cari.no_rujukan = null
                    if(res.code > 0){
                        
                            if(res.data.flag_halangan_id == null){ 

                                this.form.hm_akaun_id = res.data.id;
                                // this.form.hm_cukai = res.data.hm_cukai;
                                this.form.profil_nama = res.data.profil_nama;
                                this.form.keluasan = res.data.keluasan;
                                this.form.no_hm = res.data.no_hm;
                                this.form.jabatan_id = res.data.jabatan.id;
                                this.form.alamat = res.data.alamat;
                                this.form.daerah = res.data.daerah_keterangan;
                                this.form.hm_jenis = res.data.hm_jenis_keterangan;
                                this.form.hm_kegunaan = res.data.hm_kegunaan_keterangan;
                                this.form.mukim = res.data.mukim_keterangan;
                                this.form.tarikh_daftar = res.data.tarikh_daftar;
                                this.form.no_lot = res.data.no_lot;
                                this.form.jabatan = res.data.jabatan_keterangan;
                                this.form.nama = res.data.nama;
                                this.form.no_kp = res.data.no_kp;
                                this.form.unit_keterangan = res.data.unit_keterangan;
                                this.form.amaun = res.data.amaun;
                                this.form.amaun_jumlah = res.amaun_jumlah_cukai;


                                var proses = 1;
                                for (var j in this.hm_cukai) {
                                    if(res.data.no_hm == this.hm_cukai[j].no_rujukan){
                                        proses = 0;
                                    }

                                }
                                if(proses == 1){
                                    this.hm_cukai.push({
                                        jabatan_id: res.data.jabatan.id,
                                        no_rujukan: res.data.no_hm,
                                        amaun_asal: res.data.amaun,
                                        amaun: res.data.amaun,
                                        profil_id: res.data.profil_id,
                                        hm_cukai: res.data.hm_cukai,
                                        baki: res.data.amaun,
                                        profil_nama: res.data.profil_nama,
                                        nama: res.data.nama,
                                        id: res.data.id,
                                        rm_debit: res.data.rm_debit,
                                        rm_kredit: res.data.rm_kredit,
                                        rm_resit: res.data.rm_resit,
                                        rm_diskaun: res.data.rm_diskaun,
                                        rm_ampun_hasil: res.data.rm_ampun_hasil,
                                        baki: res.data.baki,
                                        json : res.data
                                        // json : res.data.hm_cukai
                                    });
                                    
                                    this.form.hm_cukai = this.hm_cukai;
                                }
                            }else{
                                this.halangan = res.data.halangan_keterangan
                            }
                    }

                    this.cekAmaunCukai();
                });
            }
        },

        submitTerimaanPukal() {
                if (this.form.valid == true && this.form.profil_id !=null) {
                    this.form.valid = false
                    this.$zcomm
                        .post(this.resourceurl, this.form)
                        .then((res) => {
                            if (typeof this.onAfterAdd === "function") {
                                this.onAfterAdd();
                            }

                            this.$zutil.notify("Rekod telah berjaya dihantar");
                            // this.$inertia.visit(this.$route('kutipan.mel.semak', res.id));
                                this.$inertia.visit(window.route('kutipan.mel.index'));
                            // this.$inertia.visit(
                            //     this.$route("kutipan.terimaan_pukal.index") + res
                            // );
                        })
                        .catch((err) => {})
                        .finally(() => {});
                }
            // }
        },


       


        profilhm() {
            this.dialogProfilhm.show = 1;
        },

        cariProfilhm() {

            this.dialog.loading = true;

            if (this.carian_profil_hm.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_kutipan + "carianprofil",
                        this.carian_profil_hm,
                        {}
                    )
                    .then((res) => {
                        this.draf_akaun = res.hm_akaun;
                        // this.draf_inbois = res.inbois;
                        this.dialog.loading = false;
                    });
                    
            }
        },

        

        cekPilih() {
            for (var i in this.draf_akaun) {
                this.draf_akaun[i].pilih_akaun = this.pilih_akaun;
            }
           
        },
       
        hantarRujukan() {
            // if (this.draf_akaun) {
            var no_hm = "";
            for (var i in this.draf_akaun) {
                if (this.draf_akaun[i].pilih_akaun == true) {
                    this.form.hm_akaun_id = this.draf_akaun[i].id;
                    // this.form.hm_cukai = res.data.hm_cukai;
                    this.form.profil_nama = this.draf_akaun[i].profil_nama;
                    this.form.keluasan = this.draf_akaun[i].keluasan;
                    this.form.no_hm = this.draf_akaun[i].no_hm;
                    this.form.jabatan_id = this.draf_akaun[i].jabatan.id;
                    this.form.alamat = this.draf_akaun[i].alamat;
                    this.form.daerah = this.draf_akaun[i].daerah_keterangan;
                    this.form.hm_jenis = this.draf_akaun[i].hm_jenis_keterangan;
                    this.form.hm_kegunaan = this.draf_akaun[i].hm_kegunaan_keterangan;
                    this.form.mukim = this.draf_akaun[i].mukim_keterangan;
                    this.form.tarikh_daftar = this.draf_akaun[i].tarikh_daftar;
                    this.form.no_lot = this.draf_akaun[i].no_lot;
                    this.form.jabatan = this.draf_akaun[i].jabatan_keterangan;
                    this.form.nama = this.draf_akaun[i].nama;
                    this.form.no_kp = this.draf_akaun[i].no_kp;
                    this.form.unit_keterangan = this.draf_akaun[i].unit_keterangan;
                    var proses = 1;
                    for (var j in this.hm_cukai) {
                        if(this.draf_akaun[i].no_hm == this.hm_cukai[j].no_rujukan){
                            proses = 0;
                        }
                    }
                    if(proses == 1){
                        this.hm_cukai.push({
                            jabatan_id: this.draf_akaun[i].jabatan.id,
                            no_rujukan: this.draf_akaun[i].no_hm,
                            amaun: this.draf_akaun[i].amaun,
                            amaun_asal: this.draf_akaun[i].amaun,
                            profil_id: this.draf_akaun[i].profil_id,
                            hm_cukai: this.draf_akaun[i].hm_cukai,
                            baki: this.draf_akaun[i].amaun,
                            profil_nama: this.draf_akaun[i].profil_nama,
                            nama: this.draf_akaun[i].nama,
                            id: this.draf_akaun[i].id,
                            rm_debit: this.draf_akaun[i].rm_debit,
                            rm_kredit: this.draf_akaun[i].rm_kredit,
                            rm_resit: this.draf_akaun[i].rm_resit,
                            rm_diskaun: this.draf_akaun[i].rm_diskaun,
                            rm_ampun_hasil: this.draf_akaun[i].rm_ampun_hasil,
                            baki: this.draf_akaun[i].baki,
                            json : this.draf_akaun[i]
                            // json : this.draf_akaun[i].hm_cukai
                        });
                    }
                }

                this.form.hm_cukai = this.hm_cukai;
            }

           

            // }
            // this.cekAmaunButiran();
            this.cekAmaunCukai();
            this.dialogProfilhm.show = false;
            this.reset();
        },
        
        reset() {
            this.carian_profil_hm = { q: "" };
            this.draf_akaun = [
                {
                    jabatan_keterangan: "",
                    no_hm: "",
                    amaun: "",
                    pilih_inbois: "",
                },
            ];
        },

         
     profil(){
      this.dialogProfil.show = 1
    },

    cariProfil(){
      if(this.carian_profil.q.length > 1){
        this.$zcomm.post(this.service_bil_pelbagai+"lookup/profil", this.carian_profil, {})
        .then(res => {
          console.log(res)
            this.profils = res
          })
      }
    },

    pilihProfil(dt){
      this.form.profil_keterangan = dt.label;
      this.form_cari.id = dt.value;
      this.profilDetail();
    },


    

    poskodDetail() {
      
    this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
              this.form_profil.negeri = res.negeri;
              this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
              this.form_profil.bandar = res.bandar;
              this.form_profil.lkp_jenis_alamat_id = 1;
            });
    },
     profilDetail() {
        // alert('w234')
      
      this.$zcomm.get(this.service_bil_pelbagai+'profil/'+this.form_cari.id).then(res => {
              this.form.profil_id = res.id;
              this.form.no_id = res.no_id;
              this.form.nama = res.nama;
              this.form.alamat1 = res.alamat1;
              this.form.alamat2 = res.alamat2;
              this.form.alamat3 = res.alamat3;
              this.form.poskod = res.poskod;
              this.form.bandar = res.bandar;
              this.form.negeri = res.negeri;
              this.form.kategori = res.kategori;
              
            });
      this.dialogProfil.show = false
    },
    
    submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
    },
    watch: {
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },

    },
    mounted() {
        
    },
};
</script>
